import React from 'react';
import { Container, Row, Col, Label, Input } from 'reactstrap'
import i18n from "../../../i18next";

import RefundSearch from './RefundSearch';
import OrderSearch from './OrderSearch';
import NotificationSearch from './NotificationSearch';

class CustomerTimelineSearchSelection extends React.Component {

    state = {
        contentType: 'orderSearch',
    }

    renderCustomerTimelineSearchTypeDropdown = () => {
        return (
            <Container fluid style={{ borderBottom: '1px solid rgb(33,150,214)', paddingBottom: '20px', marginBottom: '30px' }}>
                <Row>
                    <Label
                        for='customerTimelineSelectionInput'
                        style={{ marginRight: '25px', display: 'flex', alignItems: 'center' }}
                    >
                        {i18n.t('screens:customerInsightScreen.selectTypeSearch')}
                    </Label>
                    <Col sm={3} style={{ paddingLeft: 0 }} >
                        <Input
                            type="select"
                            name="customerTimelineSelectionInput"
                            id="customerTimelineSelectionInput"
                            value={this.state.contentType}
                            onChange={(e) => this.setState({ contentType: e.target.value })}>
                            <option value='orderSearch'>{i18n.t('screens:customerInsightScreen.orderSearch')}</option>
                            <option value='refundSearch'>{i18n.t('screens:customerInsightScreen.refundSearch')}</option>
                            <option value='notificationSearh'>{i18n.t('screens:customerInsightScreen.notificationSearh')}</option>
                        </Input>
                    </ Col>
                </Row>
            </Container>
        );
    }

    render() {

        return (
            <React.Fragment>
                {this.renderCustomerTimelineSearchTypeDropdown()}
                {this.state.contentType === 'orderSearch' ?
                    <OrderSearch restaurantId={this.props.restaurantId} customerId={this.props.customerId} /> :
                    this.state.contentType === 'refundSearch' ?
                        <RefundSearch restaurantId={this.props.restaurantId} customerId={this.props.customerId} /> :
                        <NotificationSearch restaurantId={this.props.restaurantId} customerId={this.props.customerId} />
                }
            </React.Fragment>
        );
    }

}

export default CustomerTimelineSearchSelection;


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/CustomerTimelineSearchSelection.js